/* CUPE.RO | Product-image save deterrent | 2026-10-23 v2
 *
 * Covers Shopify Trade product-card image links (including CSS ::after
 * overlays), product galleries, thumbnails and quick-add product media.
 * Delegated capture listeners also work with lazy-loaded / AJAX cards.
 *
 * This only affects ordinary webpage context-menu and drag events.
 * Browsers may deliberately bypass the page handler with Shift + right-click.
 * It is not DRM. Normal left-click navigation, zoom and swipes are untouched.
 */
(function () {
  'use strict';

  var PRODUCT_MEDIA = [
    '.product__media',
    '.product-media-container',
    '.product__media-gallery',
    '.product-media-modal',
    '.product__media-list',
    '.product__modal-opener',
    '.thumbnail-list img',
    '.quick-add-modal .media img',
    '.featured-product .media img'
  ].join(', ');

  var CARD = '.card-wrapper, .product-card-wrapper, .card--standard, .card--card';
  var PRODUCT_LINK = 'a[href*="/products/"]';
  var CARD_MEDIA = '.card__media, .card__inner .media';

  function elementFrom(target) {
    if (!target) return null;
    return target.nodeType === 1 ? target : target.parentElement || null;
  }

  function protectedTarget(target) {
    var el = elementFrom(target);
    if (!el || typeof el.closest !== 'function') return false;

    // Gallery images, thumbnails and their media containers on product pages.
    if (el.closest(PRODUCT_MEDIA)) return true;

    // Collection/search/home product cards often place the clickable product
    // link *over* the image via a pseudo-element. The event target is then
    // the <a>, not the <img>. Protect that specific link and image area.
    var card = el.closest(CARD);
    if (!card || !card.querySelector(PRODUCT_LINK)) return false;

    var imageArea = el.closest(CARD_MEDIA);
    if (imageArea && card.contains(imageArea)) return true;

    var link = el.closest(PRODUCT_LINK);
    return !!(link && card.contains(link));
  }

  function preventOnProduct(event) {
    if (protectedTarget(event.target) && event.cancelable) {
      event.preventDefault();
    }
  }

  // Capture phase: catch the image, its product link, or a CSS link overlay.
  // No click/keydown interception: customers can still open product pages.
  document.addEventListener('contextmenu', preventOnProduct, {capture: true, passive: false});
  document.addEventListener('dragstart', preventOnProduct, {capture: true, passive: false});
})();
